export const fixImagePath = (apiUrl, target) => {
  const baseUrl = apiUrl
  const resolve = '/media/cache/resolve/images_thumbnail/'
  const suffix = target.src.split('/images/')[1]
  if (!suffix || !baseUrl || !target) return
  target.src = baseUrl + resolve + suffix
}
